import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IRootState } from 'app/shared/reducers';
import { logout } from 'app/modules/user/service/userService';
import { AuthenticationState } from 'app/modules/user/service/store/state';
import Loader from 'app/shared/components/spb/loader/loader';

export const Logout = () => {

  const dispatch = useDispatch();
  const authentication: AuthenticationState = useSelector<IRootState>(state => state.authentication) as AuthenticationState;
  const logoutUrl = authentication.logoutUrl;
  const idToken = authentication.idToken;

  useEffect(() => {
    dispatch(logout());
  }, []);


  useEffect(() => {
    if (logoutUrl) {
      window.location.href = logoutUrl.includes('/protocol')
        ? logoutUrl + '?redirect_uri=' + window.location.origin
        : logoutUrl + '?id_token_hint=' + idToken + '&post_logout_redirect_uri=' + window.location.origin;
    }
  }, [logoutUrl]);

  return (
    <div className="p-5">
      <Loader />
    </div>
  );
};
